import {TableBase, TableBody, TableHeader, TableHeaderCell} from '@hm/fundamental'
import {FieldArrayWithId, UseFieldArrayRemove} from 'react-hook-form'
import {useTranslation} from 'react-i18next'

import {DrillingZonesTableRow} from './DrillingZonesTableRow'

import {DrillingZone} from '@refra/modules/refra-planning/types'

type DrillingZonesTableProps = {
  fields: FieldArrayWithId<{drillingZones: DrillingZone[]}, 'drillingZones'>[]
  remove: UseFieldArrayRemove
  kilnLength: number
}
export const DrillingZonesTable = ({fields, remove, kilnLength}: DrillingZonesTableProps) => {
  const {t: translate} = useTranslation()
  const tableHeaders = [
    {key: 'name', label: translate('common.name')},
    {key: 'threshold', label: translate('plantSetup.drillingZone.chartLegend.threshold')},
    {key: 'start', label: translate('common.start')},
    {key: 'end', label: translate('common.end')},
    {key: 'actions', label: ''}
  ]

  const renderRows = () =>
    fields.map((drillingZone, index) => (
      <DrillingZonesTableRow
        key={`drillingZones.${index}.row`}
        drillingZone={drillingZone}
        index={index}
        remove={remove}
        numberOfRows={fields.length - 1}
        kilnLength={kilnLength}
      />
    ))

  return (
    <TableBase data-cy="drilling_zones_table">
      <TableHeader data-cy="drilling_zones_table_head">
        {tableHeaders.map(({key, label}) => {
          return (
            <TableHeaderCell key={key} className="text-center">
              {label}
            </TableHeaderCell>
          )
        })}
      </TableHeader>
      <TableBody>{renderRows()}</TableBody>
    </TableBase>
  )
}
